import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PrincipalService } from 'app/services/auth/principal.service';
import { PermissionService } from 'app/services/auth/permission.service';
import {
  EnrichedRegistrationWithMembers,
  EnrichedWaitingListRegistrationWithMembers,
  isWailingListRegistration,
} from 'app/entities/registration/registration.types';
import { Event } from 'app/entities/event/event.types';
import { sortByAttrAsc } from 'app/services/utils.service';
import { missingMusicTrackCount } from 'app/entities/registration/missing-music';

@Component({
  selector: 'registration-row',
  templateUrl: 'registration-row.html',
  styles: [
    `
      .email {
        font-weight: bold;
        color: greenyellow;
      }
    `,
  ],
  standalone: false
})
export class RegistrationRowComponent implements OnInit {
  @Input() event: Event;
  @Input() teamCompetitionEnabled: boolean;
  @Input() registration: EnrichedRegistrationWithMembers | EnrichedWaitingListRegistrationWithMembers;
  @Input() mode: 'FULL' | 'MOBILE';
  @Input() isEventOrganizerUser: boolean;
  @Input() type: string;
  @Input() extraClass = '';
  @Output() onSelectionChanged = new EventEmitter();
  getCurrentUserOrgId;
  isCollapsed = true;
  clubName: string;
  isMagTeamRegistration: boolean;
  selected: boolean = false;
  userCanPromoteFromWaitingList: boolean;

  constructor(private principalService: PrincipalService, private permissionService: PermissionService) {}

  ngOnInit() {
    this.getCurrentUserOrgId = () => this.principalService.getCurrentUserOrgId();
    this.userCanPromoteFromWaitingList = this.permissionService.hasAdminAccessToEvent(this.event);
    this.isMagTeamRegistration =
      this.registration.sportType === 'MAG' && this.registration.extraAttributes.teamCompetition;
    this.registration.members.sort(sortByAttrAsc('lastName'));
    this.updateClubName();
  }

  missingMusicCount() {
    return missingMusicTrackCount(this.registration);
  }

  isMusicMissing() {
    return this.missingMusicCount() > 0;
  }

  collapseRow() {
    this.isCollapsed = true;
    this.updateClubName();
  }

  selectionChanged() {
    this.onSelectionChanged.emit({ registration: this.registration, selected: this.selected });
  }

  updateClubName() {
    this.clubName = this.registration.clubName;
    if (this.registration.owners && this.registration.owners.length > 1) {
      this.clubName = this.registration.owners
        .map((club) => {
          return club.name;
        })
        .sort()
        .join(', ');
    }
  }

  getRowClasses() {
    return {
      [this.extraClass]: true,
      'cancelled-registration-row': this.registration.status === 'CANCELLED' && this.isCollapsed,
      'category-registrations__participant-row_waiting-list': this.type === 'WAITING_LIST',
    };
  }

  waitingListPosition(
    registration: EnrichedRegistrationWithMembers | EnrichedWaitingListRegistrationWithMembers
  ): number | undefined {
    return isWailingListRegistration(registration) ? registration.waitingListPosition : undefined;
  }
}
